import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const isoDate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function mondayOf(offset = 0) {
  const d = new Date();
  const day = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - day + offset * 7);
  d.setHours(0, 0, 0, 0);
  return d;
}

export default function WeekGrid({ slots, monday, onPrev, onNext, onToday, renderCell, testid = "week-grid" }) {
  const weekDays = Array.from({ length: 7 }, (_, i) => {
    const d = new Date(monday);
    d.setDate(d.getDate() + i);
    return d;
  });
  const todayIso = isoDate(new Date());

  return (
    <div data-testid={testid}>
      <div className="flex items-center gap-2 mb-4">
        <Button variant="outline" size="icon" className="rounded-full h-9 w-9" onClick={onPrev} data-testid="week-prev"><ChevronLeft className="w-4 h-4" /></Button>
        <Button variant="outline" size="sm" className="rounded-full" onClick={onToday} data-testid="week-today">This week</Button>
        <Button variant="outline" size="icon" className="rounded-full h-9 w-9" onClick={onNext} data-testid="week-next"><ChevronRight className="w-4 h-4" /></Button>
        <span className="text-sm font-semibold ml-2">{isoDate(weekDays[0])} → {isoDate(weekDays[6])}</span>
      </div>
      <div className="overflow-x-auto rounded-2xl border border-[#E8E6E1] bg-white">
        <div className="min-w-[860px]">
          <div className="grid" style={{ gridTemplateColumns: "76px repeat(7, 1fr)" }}>
            <div className="bg-[#FDFBF7] border-b border-[#F0EFEB]" />
            {weekDays.map((d) => {
              const active = isoDate(d) === todayIso;
              return (
                <div key={isoDate(d)} className={`text-center py-2.5 border-b border-l border-[#F0EFEB] ${active ? "bg-[#0EA5A5]/10" : "bg-[#FDFBF7]"}`}>
                  <p className="text-[10px] uppercase tracking-wide text-[#787672]">{d.toLocaleDateString("en", { weekday: "short" })}</p>
                  <p className={`font-serif font-bold ${active ? "text-[#0EA5A5]" : ""}`}>{d.getDate()}</p>
                </div>
              );
            })}
            {slots.map((s) => (
              <React.Fragment key={s.id}>
                <div className="text-[11px] text-[#787672] py-2 pr-2 text-right border-t border-[#F0EFEB] flex items-start justify-end">{s.start_time}</div>
                {weekDays.map((d) => (
                  <div key={isoDate(d) + s.id} className="border-t border-l border-[#F0EFEB] min-h-[56px] p-1 space-y-1">
                    {renderCell(isoDate(d), s.id, s)}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
